import {
  DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  DRIFT_CHAT_SCENARIO_EXECUTION_DIMENSIONS,
} from 'cube/constants'

import type { CubeQuery } from '@driftt/dds.reports'

export const ReviewableBionicMessages: CubeQuery = {
  name: 'ReviewableBionicMessages',
  queryName: 'ReviewableBionicMessages',
  query: {
    dimensions: [
      DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.CONVERSATION_ID,
      DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.END_USER_MESSAGE_BODY,
      DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.BOT_RESPONSE_MESSAGE_BODY,
      DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.BOT_RESPONSE_MESSAGE_ID,
      DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.BOT_RESPONSE_MESSAGE_BODY_HTML,
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_SCENARIO_EXECUTION_DIMENSIONS.SCENARIO_NAME,
      DRIFT_CHAT_SCENARIO_EXECUTION_DIMENSIONS.SCENARIO_ID,
      DRIFT_CHAT_SCENARIO_EXECUTION_DIMENSIONS.SCENARIO_TYPE,
    ],
    order: [
      [DRIFT_CHAT_BIONIC_RATABLE_MESSAGES_DIMENSIONS.CONVERSATION_ID, 'desc'],
    ],
  },
}
